import { render } from "./DialogFrame.vue?vue&type=template&id=f96a80c2&scoped=true&ts=true"
import script from "./DialogFrame.vue?vue&type=script&lang=ts"
export * from "./DialogFrame.vue?vue&type=script&lang=ts"

import "./DialogFrame.vue?vue&type=style&index=0&id=f96a80c2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96a80c2"]])

export default __exports__